export default __webpack_public_path__ + "static/media/buy3.9e03ba30.png";